module.exports = __webpack_public_path__ + "media/images/team__hyflyersgc-979808879476b5bf9af42bdaae7eaf6a.png";